import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
    standalone: false,
    selector: "app-right-aside-nav-2",
    templateUrl: "./right-aside-nav-2.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class RightAsideNav2Component implements OnInit, AfterViewInit {

    visible: boolean;
    rows: any[] = [];

    constructor() {
        localStorage.removeItem('rightAside-2');
    }
    ngOnInit() {
        this.checkRightAside2();
    }

    checkRightAside2() {
        if (localStorage.getItem('rightAside-2')) {
            $('[data-toggle="m-tooltip"]').tooltip('dispose');
            let rightAside = JSON.parse(localStorage.getItem('rightAside-2'));
            if (rightAside) {
                this.visible = rightAside.visible;
                this.rows = rightAside.rows;
            }
            else this.visible = false;
        }
        else {
            setTimeout(() => {
                this.checkRightAside2();
            }, 1000);
        }
    }

    ngAfterViewInit() {
        $('[data-toggle="m-tooltip"]').tooltip();
    }

}
